import { Meter } from 'grommet/components/Meter';
import styled from 'styled-components';
import { gray1 } from '../../globals/colors';

export const OuterMeter = styled(Meter)`
    box-shadow: 0 0 0 3px ${gray1}, 0 0 0 4px #888;
`;
